"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regeneratorKeys2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regeneratorKeys.js"));
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = _interopRequireDefault(require("lodash"));
var _index = require("./index");
var _index2 = _interopRequireDefault(require("../../../../components/ActivationCode/index.vue"));
var _cookie = require("@/utils/cookie");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _log = require("@/utils/log");
var _loop = require("@/api/loop");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _vuex = require("vuex");
var _releaseNote = require("@/log/release-note");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var POPUP_MESSAGE_MAX_LENGTH = 600;
// While testing with character limit in the input box (textarea), it always occupies 7 characters. Therefore, we add this buffer.
var INPUT_BOX_LENGTH_BUFFER = 7;
var PROGRAM_DESCRIPTION_MAX_LENGTH = 140;
var _default = exports.default = {
  name: "LoopMain",
  components: {
    LoopGeninfo: _index.LoopGeninfo,
    LoopProgram: _index.LoopProgram,
    LoopParticipant: _index.LoopParticipant,
    LoopStaff: _index.LoopStaff,
    LoopCode: _index.LoopCode,
    ActivationCode: _index2.default,
    LoopEmailSetting: _index.LoopEmailSetting
  },
  props: {
    displayType: {
      type: String,
      default: "create"
    }
  },
  data: function data() {
    return {
      fullscreenloading: false,
      recordStatus: "",
      flagRemindSave: false,
      loopForm: {
        id: "",
        title: "",
        publish: "",
        type: "",
        color: "",
        start: {
          utc: "",
          timezone: _momentTimezone.default.tz.guess(),
          local: ""
        },
        end: {
          utc: "",
          timezone: _momentTimezone.default.tz.guess(),
          local: ""
        },
        locale: "",
        description: "",
        programs: [],
        staff: [],
        welcomeBox: {
          //coachUuid: "",
          //coachUgivenName: "",
          coachHtmlTips: "",
          resource: "",
          resourceTitle: ""
        },
        internal: {
          title: "",
          opportunityNumber: "",
          clientName: "",
          remark: ""
        },
        pid: "",
        metadata: {
          tenant: ""
        },
        modifiedBy: "",
        createdAt: "",
        updatedAt: "",
        automatedEmail: []
      },
      selectShowButton: [],
      oldClientPocList: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["email"])),
  created: function created() {
    if (this.displayType === "edit") {
      var id = typeof this.$route.params.id === "undefined" ? this.loopForm.id : this.$route.params.id;
      this.recordStatus = "edit";
      this.fromId = typeof this.$route.query.fromId === "undefined" ? "" : this.$route.query.fromId;
      this.getLoop(id, false); // copy mode is false
    } else if (this.displayType === "createfromcopy") {
      this.fromId = typeof this.$route.query.fromId === "undefined" ? "" : this.$route.query.fromId;
      this.getLoop(this.fromId, true);
    } else {
      // create from new
      this.recordStatus = "create";
    }
  },
  methods: {
    doCreate: function doCreate(publishStatus) {
      var _this = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var token, oEmail, msg, _msg, _msg2, _msg3, startDate, endDate, _msg4, _msg5, _msg6, programLength, stageIndex, _startDate, _endDate, _msg7, data, _t, _t2;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.fullscreenloading = true;
              token = (0, _cookie.getCookie)("ACCESS_TOKEN");
              oEmail = (0, _cookie.getCookie)("EMAIL");
              _this.loopForm.publish = publishStatus;

              // validate
              if (!(_this.loopForm.metadata.tenant === "")) {
                _context.n = 1;
                break;
              }
              _this.fullscreenloading = false;
              msg = "Please select the tenant";
              (0, _log.displayPopupMessage)(msg, "error");
              return _context.a(2);
            case 1:
              if (!(_this.loopForm.type === "")) {
                _context.n = 2;
                break;
              }
              _this.fullscreenloading = false;
              _msg = "Loop's type is missing";
              (0, _log.displayPopupMessage)(_msg, "error");
              return _context.a(2);
            case 2:
              if (!(_this.loopForm.title === "")) {
                _context.n = 3;
                break;
              }
              _this.fullscreenloading = false;
              _msg2 = "Loop's Title is missing";
              (0, _log.displayPopupMessage)(_msg2, "error");
              return _context.a(2);
            case 3:
              if (!(_this.loopForm.start.utc === "" || _this.loopForm.end.utc === "")) {
                _context.n = 4;
                break;
              }
              _this.fullscreenloading = false;
              _msg3 = "Loop's event time is missing";
              (0, _log.displayPopupMessage)(_msg3, "error");
              return _context.a(2);
            case 4:
              startDate = new Date(_this.loopForm.start.utc);
              endDate = new Date(_this.loopForm.end.utc);
              if (!(startDate > endDate)) {
                _context.n = 5;
                break;
              }
              _this.fullscreenloading = false;
              _msg4 = "Start-Time is later than End-Time in Loop event time";
              (0, _log.displayPopupMessage)(_msg4, "error");
              return _context.a(2);
            case 5:
              if (!(_this.loopForm.start.timezone === "" || _this.loopForm.end.timezone === "")) {
                _context.n = 6;
                break;
              }
              _this.fullscreenloading = false;
              _msg5 = "Timezone is missing";
              (0, _log.displayPopupMessage)(_msg5, "error");
              return _context.a(2);
            case 6:
              if (!(_this.loopForm.welcomeBox.coachHtmlTips === "")) {
                _context.n = 7;
                break;
              }
              _this.fullscreenloading = false;
              _msg6 = "Loop's Welcome Message is missing";
              (0, _log.displayPopupMessage)(_msg6, "error");
              return _context.a(2);
            case 7:
              programLength = typeof _this.loopForm.programs === "undefined" ? 0 : _this.loopForm.programs.length;
              if (!(programLength > 0)) {
                _context.n = 11;
                break;
              }
              _t = (0, _regeneratorKeys2.default)(_this.loopForm.programs);
            case 8:
              if ((_t2 = _t()).done) {
                _context.n = 11;
                break;
              }
              stageIndex = _t2.value;
              if (!((_this.loopForm.programs[stageIndex].start.utc === "" || _this.loopForm.programs[stageIndex].end.utc === "") && _this.loopForm.publish !== "draft")) {
                _context.n = 9;
                break;
              }
              _this.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Event time is missing in Program " + (1 * stageIndex + 1), "error");
              return _context.a(2);
            case 9:
              _startDate = new Date(_this.loopForm.programs[stageIndex].start.utc);
              _endDate = new Date(_this.loopForm.programs[stageIndex].end.utc);
              if (!(_startDate > _endDate && _this.hikeForm.publish !== "draft")) {
                _context.n = 10;
                break;
              }
              _this.fullscreenloading = false;
              _msg7 = "Start-Time is later than End-Time in Program " + (1 * stageIndex + 1) + " event time";
              (0, _log.displayPopupMessage)(_msg7, "error");
              return _context.a(2);
            case 10:
              _context.n = 8;
              break;
            case 11:
              // Reset Id to '' if copy
              // if (this.loopForm.id === "copy") {
              //   this.loopForm.id = "";
              // }

              // submit
              if (_this.loopForm.id === "" || _this.loopForm.id === "copy") {
                data = _lodash.default.cloneDeep(_this.loopForm); // LHVO-4155 Do not pass resource if it is empty
                if (data.welcomeBox.resource === "") {
                  delete data.welcomeBox.resource;
                }
                data.programs.forEach(function (program, index) {
                  if (program.options.length > 0) {
                    program.options.forEach(function (item, index) {
                      if (item.objectId === "" || item.objectId === undefined || item.objectId === null) {
                        program.options.splice(index, 1);
                      }
                    });
                  }
                });
                data.id = "";
                delete data.createdAt;
                delete data.updatedAt;
                console.info(data);
                (0, _loop.createLoop)(token, data).then(function (response) {
                  (0, _log.showDebugLog)("Loop-create-response1", response);
                  _this.fullscreenloading = false;
                  _this.loopForm.id = response.data.id;
                  _this.loopForm.publish = response.data.publish;

                  // console.log('Success create', this.displayType)
                  var msg = "".concat(response.data.title, " (").concat(response.data.id, ") is created.");
                  (0, _log.displayPopupMessage)(msg, "success");

                  // this.isCreatedRecord = true

                  (0, _ga.writeGaEvent)(_this, "Loop", "".concat(_lifehikesInitData.userEvent.loop.create), oEmail, "Loop Id: ".concat(_this.loopForm.id));
                  var keys_to_keep = ["role", "user"];
                  var result = _this.loopForm.staff.map(function (e) {
                    var obj = {};
                    keys_to_keep.forEach(function (k) {
                      return obj[k] = e[k];
                    });
                    return obj;
                  });
                  (0, _ga.writeGaEvent)(_this, "Loop", "".concat(_lifehikesInitData.userEvent.loop.create), oEmail, "Staff: ".concat(JSON.stringify(result)));
                  if (_this.displayType === "createfromcopy" || _this.displayType === "create") {
                    _this.$router.push("/loop/edit/".concat(response.data.id));
                  }
                }).catch(function (error) {
                  (0, _log.showDebugLog)("loop-create-error", error);
                  _this.fullscreenloading = false;
                  (0, _log.displayPopupMessage)(error, "error");
                });
              }
            case 12:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    doSave: function doSave(publishStatus) {
      var _this2 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var token, oEmail, id, msg, _msg8, _msg9, _msg0, startDate, endDate, _msg1, _msg10, _msg11, programLength, programs, stageIndex, _startDate2, _endDate2, _msg12, nextIndex, nextProgram, nextStartDate, _msg13, options, optionIndex, data, _t3, _t4, _t5, _t6;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.fullscreenloading = true;
              token = (0, _cookie.getCookie)("ACCESS_TOKEN");
              oEmail = (0, _cookie.getCookie)("EMAIL");
              id = typeof _this2.$route.params.id === "undefined" ? _this2.loopForm.id : _this2.$route.params.id;
              _this2.loopForm.publish = publishStatus;

              // validate
              if (!(_this2.loopForm.metadata.tenant === "")) {
                _context2.n = 1;
                break;
              }
              _this2.fullscreenloading = false;
              msg = "Please select the tenant";
              (0, _log.displayPopupMessage)(msg, "error");
              return _context2.a(2);
            case 1:
              if (!(_this2.loopForm.type === "")) {
                _context2.n = 2;
                break;
              }
              _this2.fullscreenloading = false;
              _msg8 = "Loop's type is missing";
              (0, _log.displayPopupMessage)(_msg8, "error");
              return _context2.a(2);
            case 2:
              if (!(_this2.loopForm.title === "")) {
                _context2.n = 3;
                break;
              }
              _this2.fullscreenloading = false;
              _msg9 = "Loop's Title is missing";
              (0, _log.displayPopupMessage)(_msg9, "error");
              return _context2.a(2);
            case 3:
              if (!(_this2.loopForm.start.utc === "" || _this2.loopForm.end.utc === "")) {
                _context2.n = 4;
                break;
              }
              _this2.fullscreenloading = false;
              _msg0 = "Loop's event time is missing";
              (0, _log.displayPopupMessage)(_msg0, "error");
              return _context2.a(2);
            case 4:
              startDate = new Date(_this2.loopForm.start.utc);
              endDate = new Date(_this2.loopForm.end.utc);
              if (!(startDate > endDate)) {
                _context2.n = 5;
                break;
              }
              _this2.fullscreenloading = false;
              _msg1 = "Start-Time is later than End-Time in Loop event time";
              (0, _log.displayPopupMessage)(_msg1, "error");
              return _context2.a(2);
            case 5:
              if (!(_this2.loopForm.start.timezone === "" || _this2.loopForm.end.timezone === "")) {
                _context2.n = 6;
                break;
              }
              _this2.fullscreenloading = false;
              _msg10 = "Timezone is missing";
              (0, _log.displayPopupMessage)(_msg10, "error");
              return _context2.a(2);
            case 6:
              if (!(_this2.loopForm.welcomeBox.coachHtmlTips === "")) {
                _context2.n = 7;
                break;
              }
              _this2.fullscreenloading = false;
              _msg11 = "Loop's Welcome Message is missing";
              (0, _log.displayPopupMessage)(_msg11, "error");
              return _context2.a(2);
            case 7:
              programLength = typeof _this2.loopForm.programs === "undefined" ? 0 : _this2.loopForm.programs.length;
              if (!(programLength > 0)) {
                _context2.n = 30;
                break;
              }
              programs = _this2.loopForm.programs.filter(function (p) {
                return p.type !== "hike";
              });
              _t3 = (0, _regeneratorKeys2.default)(programs);
            case 8:
              if ((_t4 = _t3()).done) {
                _context2.n = 30;
                break;
              }
              stageIndex = _t4.value;
              if (!(programs[stageIndex].type === "")) {
                _context2.n = 9;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's type is missing in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 9:
              if (!(programs[stageIndex].title === "")) {
                _context2.n = 10;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's title is missing in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 10:
              if (!(programs[stageIndex].title.length > 50)) {
                _context2.n = 11;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's title max length is 50 in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 11:
              if (!(programs[stageIndex].icon === "")) {
                _context2.n = 12;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's Icon is missing in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 12:
              if (!(programs[stageIndex].icon !== "none" && programs[stageIndex].iconColor === "")) {
                _context2.n = 13;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's Icon Color is missing in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 13:
              if (!(programs[stageIndex].classTime.length > 100)) {
                _context2.n = 14;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's class time max length is 100 in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 14:
              if (!(typeof programs[stageIndex].shortDescription !== 'undefined' && programs[stageIndex].shortDescription.length > PROGRAM_DESCRIPTION_MAX_LENGTH)) {
                _context2.n = 15;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's description max length is " + PROGRAM_DESCRIPTION_MAX_LENGTH + " in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 15:
              if (!(programs[stageIndex].start.utc === "" || programs[stageIndex].end.utc === "")) {
                _context2.n = 16;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's Event time is missing in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 16:
              _startDate2 = new Date(programs[stageIndex].start.utc);
              _endDate2 = new Date(programs[stageIndex].end.utc);
              if (!(_startDate2 > _endDate2)) {
                _context2.n = 17;
                break;
              }
              _this2.fullscreenloading = false;
              _msg12 = "Start-Time is later than End-Time in Program " + (1 * stageIndex + 1) + " event time";
              (0, _log.displayPopupMessage)(_msg12, "error");
              return _context2.a(2);
            case 17:
              nextIndex = 1 * stageIndex + 1;
              nextProgram = programs[nextIndex]; // console.info(nextProgram);
              // console.info("new program:" + nextIndex);
              // console.info("program" + stageIndex);
              if (!(nextProgram != undefined && nextProgram !== null)) {
                _context2.n = 18;
                break;
              }
              console.info("nextStartDate:" + nextProgram.start.utc);
              console.info("startDate:" + _startDate2);
              nextStartDate = new Date(nextProgram.start.utc);
              if (!(_startDate2 > nextStartDate)) {
                _context2.n = 18;
                break;
              }
              _this2.fullscreenloading = false;
              _msg13 = "The Start-Time of Program " + (1 * stageIndex + 1) + " is later than that of Program " + (1 * nextIndex + 1);
              (0, _log.displayPopupMessage)(_msg13, "error");
              return _context2.a(2);
            case 18:
              if (!(programs[stageIndex].type === "info")) {
                _context2.n = 21;
                break;
              }
              console.info("program type:" + stageIndex + programs[stageIndex].type);
              console.info("program action text:" + stageIndex + programs[stageIndex].action.text);
              if (!(_this2.selectShowButton[stageIndex] === "Y")) {
                _context2.n = 20;
                break;
              }
              if (!(programs[stageIndex].action.text === "")) {
                _context2.n = 19;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's Call to Action Button Text is missing in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 19:
              if (!(programs[stageIndex].action.message === "")) {
                _context2.n = 20;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's Call to Action Popup Message is missing in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 20:
              if (!(programs[stageIndex].action.message.length > POPUP_MESSAGE_MAX_LENGTH + INPUT_BOX_LENGTH_BUFFER)) {
                _context2.n = 21;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's Call to Action Popup Message max length is " + POPUP_MESSAGE_MAX_LENGTH + " in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 21:
              if (!(programs[stageIndex].type === "externalAction")) {
                _context2.n = 24;
                break;
              }
              console.info("program type:" + stageIndex + programs[stageIndex].type);
              console.info("program action text:" + stageIndex + programs[stageIndex].action.text);
              if (!(programs[stageIndex].action.text === "")) {
                _context2.n = 22;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's Call to Action Button Text is missing in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 22:
              if (!(programs[stageIndex].action.url === "")) {
                _context2.n = 23;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's Call to Action URL is missing in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 23:
              if (!(programs[stageIndex].action.message.length > POPUP_MESSAGE_MAX_LENGTH + INPUT_BOX_LENGTH_BUFFER)) {
                _context2.n = 24;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's Call to Action Popup Message max length is " + POPUP_MESSAGE_MAX_LENGTH + " in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 24:
              if (!(programs[stageIndex].type === "enrollment")) {
                _context2.n = 29;
                break;
              }
              console.info("program type:" + stageIndex + programs[stageIndex].type);
              console.info("program action text:" + stageIndex + programs[stageIndex].action.text);
              if (!(programs[stageIndex].action.text === "")) {
                _context2.n = 25;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's Call to Action Button Text is missing in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 25:
              options = programs[stageIndex].options;
              if (!(options.length === 0)) {
                _context2.n = 26;
                break;
              }
              console.info("program options length:" + stageIndex + options.length);
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Program's must have at least 1 hike selected in Program " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 26:
              _t5 = (0, _regeneratorKeys2.default)(options);
            case 27:
              if ((_t6 = _t5()).done) {
                _context2.n = 29;
                break;
              }
              optionIndex = _t6.value;
              if (!(options[optionIndex].objectId === "")) {
                _context2.n = 28;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Please select a Hike from Option" + (1 * optionIndex + 1) + ' in Program' + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 28:
              _context2.n = 27;
              break;
            case 29:
              _context2.n = 8;
              break;
            case 30:
              // submit
              (0, _log.showDebugLog)("Save Form", _this2.loopForm);
              data = _lodash.default.cloneDeep(_this2.loopForm); // LHVO-4155 Do not pass resource if it is empty
              if (data.welcomeBox.resource === "") {
                delete data.welcomeBox.resource;
              }
              data.programs.forEach(function (program, index) {
                if (program.options.length > 0) {
                  program.options.forEach(function (item, index) {
                    if (item.objectId === "" || item.objectId === undefined || item.objectId === null) {
                      program.options.splice(index, 1);
                    }
                  });
                }
              });
              console.info(data);
              (0, _loop.updateLoopById)(token, id, data).then(function (response) {
                (0, _log.showDebugLog)("Loop-update-response", response);
                _this2.fullscreenloading = false;
                _this2.loopForm.id = response.data.id;
                _this2.loopForm.publish = response.data.publish;
                _this2.loopForm.staff = _this2.loopForm.staff;
                _this2.loopForm.updatedAt = response.data.updatedAt;
                var clientPocList = _this2.loopForm.staff.filter(function (row) {
                  return row.role === 'client-poc';
                });
                _this2.oldClientPocList = _lodash.default.cloneDeep(clientPocList);
                var msg = "".concat(response.data.title, " (").concat(response.data.id, ") is updated.");
                (0, _log.displayPopupMessage)(msg, "success");
                if (_this2.$refs.loopStaff) {
                  _this2.$refs.loopStaff.getStaffList();
                }
                (0, _ga.writeGaEvent)(_this2, "Loop", "".concat(_lifehikesInitData.userEvent.loop.edit), oEmail, "Edit in Loop Main - Loop Id: ".concat(_this2.loopForm.id));
                (0, _ga.writeGaEvent)(_this2, "Loop", "".concat(_lifehikesInitData.userEvent.loop.edit), _this2.email, "avoid undefined email, Edit in Loop Main - Loop Id: ".concat(_this2.loopForm.id));
                var keys_to_keep = ["role", "user"];
                var result = _this2.loopForm.staff.map(function (e) {
                  var obj = {};
                  keys_to_keep.forEach(function (k) {
                    return obj[k] = e[k];
                  });
                  return obj;
                });
                (0, _ga.writeGaEvent)(_this2, "Loop", "".concat(_lifehikesInitData.userEvent.loop.edit), oEmail, "Staff: ".concat(JSON.stringify(result)));
              }).catch(function (error) {
                (0, _log.showDebugLog)("Loop-update-error", error);
                _this2.fullscreenloading = false;
                (0, _log.displayPopupMessage)(error, "error");
              });
            case 31:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getLoop: function getLoop(id, isCopy) {
      var _this3 = this;
      var token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      this.fullscreenloading = true;
      (0, _loop.getLoopById)(token, id).then(function (response) {
        var d = response.data;
        // check error and return immediate
        if (typeof d.id === "undefined") {
          _this3.fullscreenloading = false;
          var msg = "Cannot get the loop, please contact to system administrator";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        var loop = _lodash.default.cloneDeep(d); //JSON.parse(JSON.stringify(d));
        loop.programs.forEach(function (program) {
          if (program.type === "enrollment") {
            var ops = program.options.filter(function (ele, index, arr) {
              return arr.indexOf(ele) === 0;
            });
            program.options = ops;
          }
        });
        (0, _log.showDebugLog)("Loop-getLoopById-response", d);
        (0, _log.showDebugLog)("Loop-getLoopById-response1", loop);
        _this3.loopForm = loop;
        if (isCopy) {
          //GenneralInfo
          if (_this3.$route.query.gi !== "true") {
            _this3.loopForm.type = "";
            _this3.loopForm.title = "";
            _this3.loopForm.internal.title = "";
            _this3.loopForm.description = "";
          }
          //Salesforce
          if (_this3.$route.query.sf !== "true") {
            _this3.loopForm.internal.opportunityNumber = "";
            _this3.loopForm.internal.clientName = "";
          }
          //EventTime
          if (_this3.$route.query.et !== "true") {
            _this3.loopForm.start = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
            _this3.loopForm.end = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
          }
          //Welcome Resource Setting
          if (_this3.$route.query.wrs !== "true") {
            _this3.loopForm.welcomeBox = {
              coachHtmlTips: "",
              resource: "",
              resourceTitle: ""
            };
          }
          //Programs
          if (_this3.$route.query.p !== "true") {
            _this3.loopForm.programs = [];
          }
          //Staff
          if (_this3.$route.query.s !== "true") {
            _this3.loopForm.staff = [];
          }
          //Email Settings
          if (_this3.$route.query.es !== "true" && d.automatedEmail) {
            _this3.loopForm.automatedEmail = [];
          } else {
            _this3.loopForm.automatedEmail = d.automatedEmail;
          }
        } else {
          var clientPocList = _this3.loopForm.staff.filter(function (row) {
            return row.role === 'client-poc';
          });
          console.info(clientPocList);
          _this3.oldClientPocList = _lodash.default.cloneDeep(clientPocList);
        }
        // metadata
        if (isCopy) {
          _this3.loopForm.metadata = {
            tenant: ""
          };
        } else {
          _this3.loopForm.metadata = typeof d.metadata === "undefined" ? {
            tenant: ""
          } : d.metadata;
        }

        //  createdAt and updatedAt
        if (isCopy) {
          _this3.loopForm.createdAt = "";
          _this3.loopForm.updatedAt = "";
        }
        // To Solve internal title lagging issue, use other variable name to replace.
        _this3.fullscreenloading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)("loop-getLoopById-error", error);
        _this3.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, "error");
      }).finally(function () {
        if (isCopy) {
          _this3.loopForm.id = "copy";
          _this3.loopForm.publish = "";
        }
      });
    },
    handleClick: function handleClick() {
      // do something later
      // auto save when change tab
    },
    updateParentStaff: function updateParentStaff(staff) {
      this.loopForm.staff = staff;
      (0, _log.showDebugLog)("Update loopForm-staff", this.loopForm);
    },
    updateParentGenInfo: function updateParentGenInfo(info) {
      //showDebugLog("Update loopForm", info);
      //showDebugLog("Update loopForm 1",  this.loopForm);
    },
    updateParentProgram: function updateParentProgram(res) {
      (0, _log.showDebugLog)("Parent loop-Program", res);
      this.loopForm.programs = res;
      //console.info(this.loopForm)
    },
    checkArrayLength: function checkArrayLength(obj) {
      if (Array.isArray(obj)) {
        return obj.length;
      } else {
        return 0;
      }
    },
    checkMandateFields: function checkMandateFields() {
      // LHVO-5043 - remove validation of Producer
      // console.log("form", this.loopForm.staff)
      // var manager = _.find(this.loopForm.staff, function(s) {
      //   return s.role === "manager";
      // });
      var contact = _lodash.default.find(this.loopForm.staff, function (s) {
        return s.role === "contact";
      });
      // console.log("producer", producer)
      // console.log("string length", _.trim(this.loopForm.internal.opportunityNumber).length)
      if (
      // typeof manager === "undefined" ||
      typeof contact === "undefined" || _lodash.default.trim(this.loopForm.internal.opportunityNumber).length == 0) {
        return true;
      } else {
        return false;
      }
    },
    updateSelectShowButton: function updateSelectShowButton(selectShowButton) {
      (0, _log.showDebugLog)("Parent selectShowButton", selectShowButton);
      this.selectShowButton = selectShowButton;
    },
    updateParentEmailRuleSet: function updateParentEmailRuleSet(info) {
      this.loopForm.automatedEmail = info;
    }
  }
};